import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsCheckLkGuard implements CanActivate {
  public constructor(private readonly authService: AuthService, private readonly router: Router) {}

  public canActivate(): boolean {
    if (this.authService.currentTypeTenant === 'LK') {
      this.router.navigate(['/lk/external-user']).catch(console.error);
      return false;
    }
    return true;
  }
}
